import { Card, Col, Collapse, Image, Row, Space } from 'antd';
import { nth, tail } from 'lodash';
import moment from 'moment-timezone';
import React, { useContext, useState } from 'react';
import { useMedia } from 'react-use';
import { AppContext } from '../../../../../../../AppContext';
import { AudioIcon, DownArrow, UpArrow } from '../../../../../../../assets/svg';
import {
  BREAKPOINTS,
  DATETIMEWITHBRACKET,
  GA_EVENT,
  GA_LABEL,
} from '../../../../../../../common/constants';
import { Event } from '../../../../../../../common/trackEvents';
import AudioPlayerModal from '../../../../../../../components/AudioPlayerModal';
import EllipsisText from '../../../../../../../components/EllipsisText';
import PreviousDetailsCard from './PreviousDetailsCard';

const RejectionDetails = ({ data }) => {
  const [isOpen, setIsOpen] = useState();
  const [showAudioModal, setShowAudioModal] = useState(false);
  const [audios, setAudios] = useState([]);
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);
  const latestDetails = nth(data, 0);
  const { getCurrentProjectDetail } = useContext(AppContext);
  const [isVisible, setIsVisible] = useState(false);
  const [previewImageKey, setPreviewImageKey] = useState('');
  const currentProjectDetails = getCurrentProjectDetail();

  const items = [
    {
      key: '1',
      label: (
        <div className="d-flex panel-header">
          <div className="d-flex align-center">Previous Rejection Details</div>
          <div className="ml-10 d-flex align-center">
            {isOpen ? (
              <UpArrow width="12px" height="18px" />
            ) : (
              <DownArrow height="18px" width="12px" />
            )}
          </div>
        </div>
      ),
      children: (
        <PreviousDetailsCard
          id="rejection-previous-details"
          data={tail(data)}
          setAudios={setAudios}
          showAudioModal={showAudioModal}
          setShowAudioModal={setShowAudioModal}
        />
      ),
    },
  ];

  return (
    <div className="instruction-tab-details">
      <Card id="instruction-rejection-details-card" className="instruction-tab-details-recommendation ">
        <div id="instruction-rejection-details-header" className="d-flex align-center justify-between mb-15">
          <div className="d-flex">
            <h2 id="instruction-rejection-details-title">Rejection Details</h2>
          </div>
        </div>
        <div id="instruction-rejection-details-content" className="mobile-card">
          <div id="instruction-rejection-details-latest-header" className="d-flex align-center justify-between mb-15">
            <div className="d-flex">
              <h5 id="instruction-rejection-details-latest-title">{`${data?.length}. ${latestDetails?.rejector?.name || ''} - ${
                latestDetails?.createdAt &&
                moment(latestDetails?.createdAt)
                  ?.tz(currentProjectDetails?.timeZone)
                  ?.format(DATETIMEWITHBRACKET)
              }`}</h5>
            </div>
          </div>
          <Row
            id="instruction-rejection-details-section-row"
            gutter={isDesktopViewport ? [75, 40] : [40, 30]}
            className="fw-medium mb-20"
          >
            <Col span={isDesktopViewport ? 10 : 24}>
              <div id="instruction-rejection-details-remarks-label" className="text-secondary mb-12">Remarks</div>
              <EllipsisText id="instruction-rejection-details-remarks-text" text={latestDetails?.remark || '-'} />
            </Col>
            <Col span={isDesktopViewport ? 7 : 24}>
              <Space orientation="vertical" size={12}>
              <div id="instruction-rejection-details-photos-label" className="text-secondary">Photos</div>
                <div id="instruction-rejection-details-photos-container">
                  {latestDetails?.photos?.length > 0 ? (
                    <Image.PreviewGroup
                      preview={{
                        open:
                          latestDetails?.id === previewImageKey && isVisible,
                        onOpenChange: (visible) => {
                          setIsVisible(visible);
                          if (visible) {
                            Event(GA_EVENT.OPENED_IMAGE_VIEWER, {
                              label: GA_LABEL.OPENED_IMAGE_VIEWER,
                              // eslint-disable-next-line no-undef
                              pathname: window?.location?.href,
                            });
                          }
                        },
                      }}
                    >
                      <Space className="image-preview-wrapper">
                        {React.Children.map(latestDetails?.photos, (photo, photoIndex) => (
                          <Image
                            id={`instruction-rejection-details-photo-${photoIndex}`}
                            src={photo}
                            alt="logo"
                            height="64px"
                            width="64px"
                            onClick={() =>
                              setPreviewImageKey(latestDetails?.id)
                            }
                          />
                        ))}
                        {latestDetails?.photos?.length > 1 && (
                          <div
                            id="instruction-rejection-details-photos-extra-count"
                            className="extra-count pointer"
                            onClick={() => {
                              setIsVisible(true);
                              setPreviewImageKey(latestDetails?.id);
                            }}
                          >
                            {`+${latestDetails?.photos?.length - 1}`}
                          </div>
                        )}
                      </Space>
                    </Image.PreviewGroup>
                  ) : (
                    '-'
                  )}
                </div>
              </Space>
            </Col>
            {latestDetails?.audios?.length > 0 && (
              <Col span={isDesktopViewport ? 7 : 24}>
                <Space orientation="vertical" size={12}>
                <div id="instruction-rejection-details-audio-label" className="text-secondary">Audio</div>
                  <div id="instruction-rejection-details-audio-container">
                    <div
                      id="instruction-rejection-details-audio-player"
                      className="audio-player-wrapper"
                      onClick={() => {
                        setShowAudioModal(true);
                        setAudios(latestDetails?.audios);
                        Event(GA_EVENT.DOWNLOAD_AUDIO, {
                          label: GA_LABEL.DOWNLOAD_AUDIO,
                          // eslint-disable-next-line no-undef
                          pathname: window?.location?.href,
                        });
                      }}
                    >
                      <AudioIcon />
                      {latestDetails?.audios?.length > 1 && (
                        <div id="instruction-rejection-details-audio-extra-count" className="extra-count">{`+${
                          latestDetails?.audios?.length - 1
                        }`}</div>
                      )}
                    </div>
                  </div>
                </Space>
              </Col>
            )}
          </Row>
        </div>
        <Collapse
          id="instruction-rejection-details-collapse"
          expandIconPlacement="end"
          bordered={false}
          className="recommendation-collapse"
          expandIcon={() => {}}
          onChange={(activeKey) => setIsOpen(!!activeKey?.length)}
          items={items}
        />
      </Card>
      {audios?.length > 0 && (
        <AudioPlayerModal
          id="instruction-rejection-details-audio-modal"
          audios={audios}
          showModal={showAudioModal}
          setShowModal={setShowAudioModal}
        />
      )}
    </div>
  );
};

export default RejectionDetails;
